export default class PlayData{

    constructor(){
        GAME_REF.obj.data = this;
        this.getList = [];
        this.score = 0;
    }


    addList(frameNo){
        this.getList.push(frameNo);
    }

    addScore(val){
        this.score += val;
    }
    

    get _getList(){
        return this.getList;
    }

    get _latest(){
        return this.getList[this.getList.length-1];
    }

    get _score(){
        return this.score;
    }
}